import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { linkedinApi } from '@/lib/linkedin-api';

export default function LinkedInCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (error) {
      setStatus('error');
      toast.error('Autorização LinkedIn cancelada ou falhou');
      setTimeout(() => navigate('/integrations'), 3000);
      return;
    }

    if (!code) {
      setStatus('error');
      toast.error('Código de autorização não encontrado');
      setTimeout(() => navigate('/integrations'), 3000);
      return;
    }

    // Send code to backend
    linkedinApi.callback(code, state || '')
      .then(() => {
        setStatus('success');
        toast.success('LinkedIn conectado com sucesso!');
        setTimeout(() => navigate('/integrations'), 2000);
      })
      .catch(() => {
        setStatus('error');
        toast.error('Erro ao conectar LinkedIn. Tente novamente.');
        setTimeout(() => navigate('/integrations'), 3000);
      });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        {status === 'processing' && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4" />
            <p className="text-muted-foreground">Conectando LinkedIn...</p>
          </>
        )}
        {status === 'success' && (
          <p className="text-green-600 font-medium">LinkedIn conectado! Redirecionando...</p>
        )}
        {status === 'error' && (
          <p className="text-destructive font-medium">Erro na conexão. Redirecionando...</p>
        )}
      </div>
    </div>
  );
}
